import * as React from "react";

export const IconWorkHome = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_18793_23223)">
      <path d="M8.17 5.7002L1 10.4802V21.0002H6V13.0002H10V21.0002H15V10.2502L8.17 5.7002Z" fill="white" />
      <path d="M10 3V4.51L12 5.84L13.73 7H15V7.85L17 9.19V11H19V13H17V15H19V17H17V21H23V3H10ZM19 9H17V7H19V9Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_18793_23223">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
